import { SendMidwayTemporaryPinRequestSchema } from "@amzn/client-workbench-api-model";
import { API } from "@aws-amplify/api";

import { API_METRICS_HANDLE, CLIENT_APP } from "@/apis/constants";
import { Logger } from "@/apis/Logger";
import {
  publishQueryLatencyMetrics,
  publishQueryResultMetrics,
} from "@/apis/Metrics";

import { AMPLIFY_DEFAULT_API_NAME } from "../amplifyConfig";

export const MIDWAY_API_METRIC_NAME = "MidwayPinAPICall";
export const MIDWAY_SEND_PIN_PATH = "/user/midway/pin";

/**
 * Send a temporary PIN to the NH's personal email address.
 * TODO: Retry logic
 */
export const sendTempPin = async (): Promise<void> => {
  const startTime = performance.now();

  try {
    await API.post(AMPLIFY_DEFAULT_API_NAME, MIDWAY_SEND_PIN_PATH, {
      body: {
        clientApp: CLIENT_APP,
      } as SendMidwayTemporaryPinRequestSchema,
    });
    publishQueryResultMetrics({
      metricsPublisherHandler: API_METRICS_HANDLE,
      queryFunctionName: MIDWAY_API_METRIC_NAME,
      numFailures: 0,
      numSuccess: 1,
    });
  } catch (err) {
    void Logger.errorErrorLike(
      `${MIDWAY_API_METRIC_NAME} failed API call.`,
      err
    );
    publishQueryResultMetrics({
      metricsPublisherHandler: API_METRICS_HANDLE,
      queryFunctionName: MIDWAY_API_METRIC_NAME,
      numFailures: 1,
      numSuccess: 0,
    });
    return Promise.reject(err);
  } finally {
    publishQueryLatencyMetrics({
      metricsPublisherHandler: API_METRICS_HANDLE,
      queryFunctionName: MIDWAY_API_METRIC_NAME,
      elapsedTime: performance.now() - startTime,
    });
  }
};
